import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFindMessagesStatus = createSelector(
  [(store: RootState) => store.paymentNoticeDetail.findMessagesStatus],
  (findMessagesStatus) => findMessagesStatus
);
